module.exports = __webpack_public_path__ + "img/clientes 2.c681689f.png";